import { Sparkles } from 'lucide-react';
import { useEffect, useState } from 'react';

// El asistente, a un toque desde cualquier pantalla.
//
// POR QUÉ FLOTANTE Y NO SOLO EN EL MENÚ. Quien lo necesita está en un
// pasillo, con una mano ocupada, y ya está dentro de otra pantalla. Si
// para preguntar «¿dónde están las balatas?» hay que abrir el menú y
// buscar el módulo, no se pregunta: se sigue buscando a mano, que es lo
// que esto viene a quitar.
//
// ABAJO A LA DERECHA y no arriba: es donde llega el pulgar de una mano
// en un teléfono de 6". Y con la etiqueta escrita, no solo el icono —una
// chispa sola no dice qué hace, y adivinar no es descubrir.
//
// NO SALE EN EL PROPIO ASISTENTE: un botón que lleva a donde ya estás es
// ruido, y ahí además taparía el campo de escribir.
export default function BotonAsistente({ onAbrir, activo }) {
  // MIENTRAS HAYA UN DIÁLOGO ABIERTO, EL BOTÓN SE ESCONDE (T-13). Vive abajo
  // a la derecha, justo donde un modal pone «Guardar cambios»: en pantallas
  // de ≤1054 px lo tapaba y no se podía guardar sin cerrar antes. Todos los
  // diálogos de TEGO marcan su panel con `role="dialog"` (ver `useDialogo`),
  // así que basta con vigilar si hay alguno en la página.
  const [hayDialogo, setHayDialogo] = useState(false);
  useEffect(() => {
    const mirar = () => setHayDialogo(!!document.querySelector('[role="dialog"]'));
    mirar();
    const observador = new MutationObserver(mirar);
    observador.observe(document.body, { childList: true, subtree: true });
    return () => observador.disconnect();
  }, []);

  if (activo || hayDialogo) return null;
  return (
    <button
      type="button"
      onClick={onAbrir}
      // `title` no basta: en un teléfono no hay ratón que lo muestre.
      aria-label="Abrir el asistente para preguntar dónde está algo"
      className="fixed bottom-4 right-4 z-40 inline-flex items-center gap-2
                 bg-[var(--color-marca)] hover:bg-[var(--color-marca-fuerte)]
                 text-white font-semibold pl-3.5 pr-4 py-3 rounded-full
                 shadow-lg focus:outline-none focus:ring-2
                 focus:ring-[var(--color-marca)] focus:ring-offset-2
                 print:hidden sin-imprimir"
    >
      <Sparkles className="h-5 w-5 shrink-0" aria-hidden="true" />
      Preguntar
    </button>
  );
}
